// import le fichier env.js
import { API_URL } from './env.js';

export async function getMeteo24hData() {
    const url = API_URL+"meteo24h-data";


    try {
        const reponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        if (reponse.ok) {
            return await reponse.json();
        } else {
            throw new Error('Erreur lors de la requête : ' + reponse.status);
        }
    } catch (erreur) {
        console.error('Erreur lors de la requête :', erreur);
        return null;
    }

}

export async function getMeteoDataDate(startDate, endDate) {
    const url = API_URL+"meteoDate-data";
    const params = new URLSearchParams();
    params.append('dateDebut', startDate);
    params.append('dateFin', endDate);

    try {

        const reponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: params.toString()
        });

        if (reponse.ok) {
            return await reponse.json();
        } else {
            throw new Error('Erreur lors de la requête : ' + reponse.status);
        }
    } catch (erreur) {
        console.error('Erreur lors de la requête :', erreur);
        return null;
    }
}


export async function getCumul() {
    const url = API_URL+"precipitations-data";


    try {
        const reponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        if (reponse.ok) {
            return await reponse.json();
        } else {
            throw new Error('Erreur lors de la requête : ' + reponse.status);
        }
    } catch (erreur) {
        console.error('Erreur lors de la requête :', erreur);
        return null;
    }

}

export async function getCumulJournalier() {
    const url = API_URL+"precipitationsJournaliere-data";


    try {
        const reponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        if (reponse.ok) {
            return await reponse.json();
        } else {
            throw new Error('Erreur lors de la requête : ' + reponse.status);
        }
    } catch (erreur) {
        //console.log('Hey');
        console.error('Erreur lors de la requête :', erreur);
        return null;
    }

}

export async function getCumulMensuel() {
    const url = API_URL+"precipitationsMensuel-data";


    try {
        const reponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        if (reponse.ok) {
            return await reponse.json();
        } else {
            throw new Error('Erreur lors de la requête : ' + reponse.status);
        }
    } catch (erreur) {
        //console.log('Hey');
        console.error('Erreur lors de la requête :', erreur);
        return null;
    }

}

export async function getCumulHoraire() {
    const url = API_URL+"precipitationsHoraire-data";


    try {
        const reponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        if (reponse.ok) {
            return await reponse.json();
        } else {
            throw new Error('Erreur lors de la requête : ' + reponse.status);
        }
    } catch (erreur) {
        //console.log('Hey');
        console.error('Erreur lors de la requête :', erreur);
        return null;
    }

}

export async function getCumulAnnuel() {
    const url = API_URL+"precipitationsAnnuel-data";


    try {
        const reponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        if (reponse.ok) {
            return await reponse.json();
        } else {
            throw new Error('Erreur lors de la requête : ' + reponse.status);
        }
    } catch (erreur) {
        //console.log('Hey');
        console.error('Erreur lors de la requête :', erreur);
        return null;
    }

}

export async function getDonneInstantanee() {
    const url = API_URL+"donneeInstantanee-data";

    try {
        const reponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        if (reponse.ok) {
            return await reponse.json();
        } else {
            throw new Error('Erreur lors de la requête : ' + reponse.status);
        }
    } catch (erreur) {
        //console.log('Hey');
        console.error('Erreur lors de la requête :', erreur);
        return null;
    }


}

export async function getDonneMensuelleDate(startDate, endDate) {
    const url = API_URL+"precipitationsMensuelDate-data";
    const params = new URLSearchParams();
    params.append('dateDebut', startDate);
    params.append('dateFin', endDate);

    try {

        const reponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: params.toString()
        });

        if (reponse.ok) {
            return await reponse.json();
        } else {
            throw new Error('Erreur lors de la requête : ' + reponse.status);
        }
    } catch (erreur) {
        console.error('Erreur lors de la requête :', erreur);
        return null;
    }
}

export async function getDonneJournalierDate(startDate, endDate) {
    const url = API_URL+"precipitationsJournaliereDate-data";
    const params = new URLSearchParams();
    params.append('dateDebut', startDate);
    params.append('dateFin', endDate);

    try {

        const reponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: params.toString()
        });

        if (reponse.ok) {
            return await reponse.json();
        } else {
            throw new Error('Erreur lors de la requête : ' + reponse.status);
        }
    } catch (erreur) {
        console.error('Erreur lors de la requête :', erreur);
        return null;
    }
}

export async function getDonneHoraireDate(startDate, endDate) {
    const url = API_URL+"precipitationsHoraireDate-data";
    const params = new URLSearchParams();
    params.append('dateDebut', startDate);
    params.append('dateFin', endDate);

    try {

        const reponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: params.toString()
        });

        if (reponse.ok) {
            return await reponse.json();
        } else {
            throw new Error('Erreur lors de la requête : ' + reponse.status);
        }
    } catch (erreur) {
        console.error('Erreur lors de la requête :', erreur);
        return null;
    }
}

export async function getDonneTelechargementDate(startDate, endDate,organisation,mail) {
    const url = API_URL+"meteoTelechargementDate-data";
    const params = new URLSearchParams();
    params.append('dateDebut', startDate);
    params.append('dateFin', endDate);
    params.append('organisation', organisation);
    params.append('mail', mail);

    try {

        const reponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: params.toString()
        });

        if (reponse.ok) {
            return await reponse.text();
        } else {
            throw new Error('Erreur lors de la requête : ' + reponse.status);
        }
    } catch (erreur) {
        console.error('Erreur lors de la requête :', erreur);
        return null;
    }
}

export async function getDonneTelechargementOldDate(startDate, endDate,organisation,mail) {
    const url = API_URL+"meteoTelechargementOldDate-data";
    const params = new URLSearchParams();
    params.append('dateDebut', startDate);
    params.append('dateFin', endDate);
    params.append('organisation', organisation);
    params.append('mail', mail);

    try {

        const reponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: params.toString()
        });

        if (reponse.ok) {
            return await reponse.text();
        } else {
            throw new Error('Erreur lors de la requête : ' + reponse.status);
        }
    } catch (erreur) {
        console.error('Erreur lors de la requête :', erreur);
        return null;
    }
}